import { authFetch } from "@/lib/authFetch";

export async function fetchLogoForDomain(emailOrWebsite: string): Promise<string | null> {
  let domain: string;
  if (emailOrWebsite.includes("@")) {
    domain = emailOrWebsite.split("@")[1];
  } else {
    try {
      domain = new URL(
        emailOrWebsite.startsWith("http") ? emailOrWebsite : `https://${emailOrWebsite}`
      ).hostname;
    } catch {
      domain = emailOrWebsite;
    }
  }
  if (!domain) return null;
  try {
    const r = await authFetch(`/api/clearbit/logo?domain=${encodeURIComponent(domain)}`);
    const d = await r.json();
    return d.logoUrl ?? null;
  } catch {
    return null;
  }
}

export function getClientInitials(name: string): string {
  return name.split(/\s+/).slice(0, 2).map(w => w[0]).join("").toUpperCase() || "?";
}

const avatarColors = [
  "bg-blue-100 text-blue-700",
  "bg-green-100 text-green-700",
  "bg-purple-100 text-purple-700",
  "bg-orange-100 text-orange-700",
  "bg-pink-100 text-pink-700",
  "bg-teal-100 text-teal-700",
];

export function ClientAvatar({
  logoUrl,
  companyName,
  size = 40,
}: {
  logoUrl?: string | null;
  companyName: string;
  size?: number;
}) {
  const initials = getClientInitials(companyName);
  const color = avatarColors[companyName.charCodeAt(0) % avatarColors.length];
  const sz = `${size}px`;
  if (logoUrl) {
    return (
      <img
        src={logoUrl}
        alt={companyName}
        style={{ width: sz, height: sz }}
        className="rounded-lg object-contain border bg-white shrink-0"
        onError={e => {
          (e.target as HTMLImageElement).style.display = "none";
        }}
      />
    );
  }
  return (
    <div
      style={{ width: sz, height: sz, fontSize: size > 32 ? "16px" : "13px" }}
      className={`rounded-lg flex items-center justify-center font-semibold shrink-0 ${color}`}
    >
      {initials}
    </div>
  );
}

export const contractLabels: Record<string, string> = {
  achat: "Achat",
  location: "Location",
  poc: "POC",
};
